import React from 'react'
import { POST } from 'api/index';
import { LoginPropType } from 'entities/interfaces'

const WithLoginData = (LoginPage: React.FC<LoginPropType>) => function WithProps() {

    const loginUser = async (email:string, password:string) => {
        const body = new URLSearchParams();
        body.append('email', email);
        body.append('password', password);

        const response = await POST('getUserInfo', body);
        return {
            status: response.status,
            content: response.content,
            message: response.error||'',
        }
    }

    const acceptPrivacy = async (token: string) => {
        const body = new URLSearchParams();
        body.append('userToken', token);
  
        const res = await POST('acceptPrivacy', body);
        return {
          status     : res.status,
          token      : res.token,          
          acceptedAt : res.acceptedAt,
          message    : res.error || '',
        };
      };

      const getPrivacyStatus = async (token: string) => {
        const body = new URLSearchParams();
        body.append('userToken', token);
  
        const res = await POST('getPrivacyStatus', body);
        return {
          status          : res.status,
          privacyAccepted : res.privacyAccepted,
          acceptedAt      : res.acceptedAt,
        };
      };
  

    return (
        <LoginPage loginUser={loginUser} acceptPrivacy={acceptPrivacy} getPrivacyStatus={getPrivacyStatus}  />
    )
}

export default WithLoginData